import { getFileExtension } from "../../form/fileUpload/utils/FileUploadFunctions";

// Formats the browser can render natively. Word/Excel have no built-in renderer,
// so anything missing from this list can only be downloaded.
export const VIEWABLE_MIME_TYPES = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  svg: "image/svg+xml",
  txt: "text/plain",
};

export function getViewableMimeType(fileName) {
  return VIEWABLE_MIME_TYPES[getFileExtension(fileName)] ?? null;
}

export function isFileViewable(fileName) {
  return Boolean(getViewableMimeType(fileName));
}

export function saveBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
